module.exports = __webpack_public_path__ + "57b9ddd5226fdb1e6c3fc88fe677272c.webp";